export default __webpack_public_path__ + "static/media/que-step1.2a0cf8cc.gif";